import React from 'react';
// import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import './missed-last-event-styles.css';
import { Link } from 'react-router-dom';
const image = require('../../assets/event1.jpg');
export const MissedLastEvent = () => {
  return (
    <div>
      <div className='img-back-box d-block d-lg-flex'>
        <img
          className='missed-event-image  d-none d-lg-block'
          src={require('../../assets/event1.jpg')}
        />
        <div className='l-left-container'>
          <h2 className='expect-heading text-white mb-0 pb-0'>
            Missed Our <span className='text-theme head-font'> Last Event?</span>
          </h2>
          <p className='l-desc'>
            Don’t worry—catch up on all the valuable insights at your own pace!
          </p>
          <p className='l-event-name mb-0'>
            <b className='text-white'>Previous Event: </b> <br /> Fast Pass Revolutionize
            Patient Schedulin
          </p>
         
          <Link
            className='l-button'
              style={{ textDecoration: 'none', color: 'white' }}
              to={'/recordings'}
            >
              Access Recording
              &#8594;
            </Link>
        </div>
      </div>
    </div>
  );
};
